import { Container } from '@chakra-ui/react'
import { SentryErrorComponent } from '@components/Fallback'
import {
  DEFAULT_LIST_ORDER,
  staffSessionRequestSchema,
  STAFF_SESSION_ORDER_BY_FIELDS,
} from '@customTypes/cloudmix/sessions'
import { ListSessions } from '@features/staffMember/components/sessions/ListSessions'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { withListHydration } from '@lib/listState/withListHydration'

const StaffSessionsRoute = () => (
  <Container maxW={'75rem'}>
    <ListSessions />
  </Container>
)

const routerSchema = staffSessionRequestSchema.partial().catch({})
const routeId = '/_auth/staff/sessions' as const

export const Route = createFileRoute(routeId)({
  component: StaffSessionsRoute,
  beforeLoad: withListHydration({
    list: {
      routeId,
      defaultSort: DEFAULT_LIST_ORDER,
      allowedOrderByFields: STAFF_SESSION_ORDER_BY_FIELDS,
    },
    getTitle: () => 'Sessions',
  }),
  errorComponent: SentryErrorComponent,
  validateSearch: zodValidator(routerSchema),
})
